import React, { ReactNode, JSX } from 'react';
import styled from '@emotion/styled';
import Overlay from './Overlay';

interface Props {
  text?: string;
  isLoading?: boolean;
  positionFixed?: boolean;
  className?: string;
  children: ReactNode;
  markup?: ReactNode;
  customSpinner?: ReactNode;
  backgroundColor?: string;
}

const Container = styled.div`
  position: relative;
  height: 100%;
`;

const LoadingOverlay = (props: Props): JSX.Element => {
  const {
    children,
    text,
    isLoading,
    positionFixed,
    className,
    markup,
    customSpinner,
    backgroundColor
  } = props;

  return (
    <Container className={className}>
      {children}
      {isLoading && (
        <Overlay
          markup={markup}
          text={text}
          positionFixed={positionFixed}
          customSpinner={customSpinner}
          backgroundColor={backgroundColor}
        />
      )}
    </Container>
  );
};
export default LoadingOverlay;
